import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=321d5f14&"
import script from "./Completed.vue?vue&type=script&lang=ts&"
export * from "./Completed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports